<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <div style="min-width: 180px;width:100%;height:100%;padding:10px 0px 10px;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :row-data="rowData"
            style="width:100%;height:100%;min-height: 500px;padding-left: 16px;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <!--返回-->
                  <el-button type="primary" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <!--编辑-->
                  <el-button type="success" @click="editHandler('edit')">{{ $t('Payment.edit2') }}</el-button>
                  <!--复制-->
                  <el-button :disabled="isEditing" type="primary" @click="copyJobHandler()">{{ $t('SeaExport.Clone') }}</el-button>
                  <!--审核通过-->
                  <el-button v-show="btn.acceptRole && !isCooperate" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && job.uuid && (currentRow.preverifyState !== 5 && currentRow.preverifyState !== 2 && currentRow.preverifyState !== 3))" type="primary" @click="acceptHandler()">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--拒绝-->
                  <el-button v-show="btn.rejectRole && !isCooperate" :disabled="!(currentRow && currentRow.jobState === -1 && !isEditing && job.uuid && (currentRow.preverifyState !== 5 && currentRow.preverifyState !== 2 && currentRow.preverifyState !== 3))" type="primary" @click="rejectHandler()">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--协作状态: 审核通过-->
                  <el-button v-show="btn.acceptRole && isCooperate" :disabled="!(currentRow && !isEditing && job.uuid && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="acceptCooperateHandler(1)">{{ $t('SeaExport.PassAudit') }}</el-button>
                  <!--协作状态: 拒绝-->
                  <el-button v-show="btn.rejectRole && isCooperate" :disabled="!(currentRow && !isEditing && job.uuid && [SystemConstants.COOPERATE_STATUS_PENDING.code].includes(currentRow.cooperateStatus))" type="primary" @click="rejectHandler(1)">{{ $t('SeaExport.Refuse') }}</el-button>
                  <!--打印-->
                  <el-button type="success" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>
                  <!--复核通过-->
                  <el-button v-show="btn.reviewThrough && btn.pretrialReviewConfig && !isCooperate" :disabled="!(currentRow && currentRow.preverifyState === 2)" type="primary" @click="btVerifyReviewThroughHandler()">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
                  <!--复核拒绝-->
                  <el-button v-show="btn.reviewRefusal && btn.pretrialReviewConfig && !isCooperate" :disabled="!(currentRow && currentRow.preverifyState === 2)" type="primary" @click="btVerifyReviewRefusalHandler()">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
                </div>
                <div v-show="isNew" class="new" style="border-left:none;padding-left:0">
                  <el-button type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button type="success" @click="cancelEdit(goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <el-button type="success" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button
                    type="success"
                    @click="cancelEdit(lookHandler)"
                  >{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="SaveTheDefaultValues2" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'||action==='edit'" style="display:flex;white-space:nowrap;">
                <!-- im入口 -->
                <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
                <el-tooltip effect="dark" :content="action==='edit' ? '' : $t('SeaExport.Tip1')" placement="bottom-start" :offset="sopTooltipOffset" :visible-arrow="false">
                  <div style="width: 100%;cursor: pointer">
                    <span class="red" style="font-size:14px;padding:5px 0">{{ commonInfo.jobState }}</span>
                    <span style="padding: 5px 9px;color:unset;" v-html="commonInfo.jobTitle" />
                    <span class="red" style="padding:5px 0">{{ commonInfo.jobLock }}</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%;"
              @tab-click="handleTabClick"
            >
              <el-tab-pane
                v-if="!masterFlag"
                :key="1"
                :lazy="true"
                name="basicTab"
                :label="$t('SeaExport.Basic')"
              >
                <tab-general-UICustom
                  v-if="$store.state.uiCustom.enable"
                  ref="basicTab"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  page-source="AeBookingVerify"
                  view-source="bookingWorkspace"
                />
                <tab-general v-else ref="basicTab" :context="context" :action="action" :cooperate-edit="cooperateEditOther" page-source="AeBookingVerify" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag"
                :key="2"
                :lazy="true"
                name="masterBasicTab"
                :label="$t('SeaExport.Basic')"
              >
                <tab-master-UICustom
                  v-if="$store.state.uiCustom.enable"
                  ref="masterBasicTab"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                />
                <tab-master
                  v-else
                  ref="masterBasicTab"
                  :context="context"
                  :action="action"
                  :is-sea-export="true"
                  :cooperate-edit="cooperateEditOther"
                  view-source="bookingWorkspace"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                />
              </el-tab-pane>
              <el-tab-pane
                :key="13"
                :lazy="true"
                name="tabCharges"
                :label="$t('SeaExport.Charge')"
              >
                <tab-charges ref="tabCharges" :context="context" :action="action" view-source="AeBookingVerify" />
              </el-tab-pane>
              <!-- 国内账单-->
              <el-tab-pane
                v-if="!isNew && privilege.chargeConfirm.chargeConfirmView"
                :key="22"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" />
              </el-tab-pane>
              <!-- 国外账单-->
              <el-tab-pane
                v-if="!isNew && privilege.billTab.billTabView"
                :key="23"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" view-source="AeBookingVerify" />
              </el-tab-pane>
              <el-tab-pane
                :key="19"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 订舱审核-通过 -->
    <accept-dialog
      v-if="acceptDialog.visible"
      :visible.sync="acceptDialog.visible"
      :job-model="acceptDialog.job || {}"
      :batch-pass-audit="acceptDialog.batchPassAudit"
      :submit-call-back="acceptDialog.submitCallBack"
      :job-list="acceptDialog.jobList || []"
    />
    <!-- 订舱审核-拒绝 -->
    <reject-dialog
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <!--部门选择-->
    <department-chooser-dialog
      :visible.sync="departmentChooserDialog.visible"
      :departments="departmentChooserDialog.departments"
      :show-cancel-btn="true"
      @callback="departmentChooserDialogCallback"
    />
    <!-- 信控验证弹框 -->
    <confirm-dialog-window
      v-if="confirmDialogWindow.visible"
      :visible.sync="confirmDialogWindow.visible"
      :message-title="confirmDialogWindow.messageTitle"
      :content="confirmDialogWindow.content"
      :show-confirm-btn="confirmDialogWindow.showConfirmBtn"
      :confirm-call-back="confirmDialogWindow.confirmCallBack"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 协作状态审核 -->
    <cooperation-verify-dialog
      v-if="cooperationVerifyDialog.visible"
      :visible.sync="cooperationVerifyDialog.visible"
      :job-uuid="cooperationVerifyDialog.jobUuid"
      :cooperate="cooperationVerifyDialog.cooperate"
      :submit-call-back="cooperationVerifyDialog.submitCallBack"
      :editable="cooperationVerifyDialog.editable"
    />
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :new-job="batchCheckingWindow.newJob"
    />
    <!-- 单条业务，配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
      :new-job="checkingWindow.newJob"
    />
  </div>
</template>

<script>
import locationImg from '@/assets/location24.png'
import { VerifyWorkspaceContext } from './verifyWorkspaceContext'
import { VerifyWorkspacePM } from './verifyWorkspacePM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill' // 国内账单
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill' // 国外账单
import URL from '@/api/urlTranslator'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import { TabError } from '@/utils/class/TabError'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { Company } from '@/class/model/mdm/Company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { ensureExecuteSuccess, deepCopy, sleep } from '@/utils/commonUtil'
import { batchCheckJobsCredit, getDepartmentIdOfRole } from '@/api/booking/job'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import acceptDialog from '@/views/cargo/v0/AirExport/components/verify/acceptDialog'
import rejectDialog from '@/views/cargo/v0/AirExport/components/verify/rejectDialog'
import { getLoading } from '@/utils/utilBaseElement'
import { getCacheListByKey, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import tabGeneral from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral'
import tabMaster from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import lodash from 'lodash'
import {
  acceptJob,
  needConfirmDepartment,
  preVerifyReject, reviewRefusal,
  reviewThrough,
  saveAeBookingSpace
} from '@/api/AirExport/airExportJob'
import departmentChooserDialog from '@/components/Cargo/Job/departmentChooserDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import ConfirmDialogWindow from '@/views/cargo/v0/SeaExport/components/verify/ConfirmDialogWindow'
import { JOB_STATES, REMOTE_BOOKING_ALL_STATES } from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import cooperationVerifyDialog from '@/components/Cargo/Job/cooperationVerifyDialog'
import { updateState } from '@/api/booking/jobCooperate'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { getImGroup } from '@/api/cargoIm'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'
import tabGeneralUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneralUICustom.vue'
import tabMasterUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMasterUICustom.vue'

export default {
  name: 'VerifyWorkspace',
  components: {
    tabGeneralUICustom,
    tabMasterUICustom,
    tabGeneral,
    tabMaster,
    tabCharges,
    tabFileHistory,
    acceptDialog,
    rejectDialog,
    DropUploader,
    tabInternalBill,
    tabOverseaBill,
    cargoAdvanceSelect,
    cargoUserSelect,
    cargoLeftRightResize,
    cargoTemplateSelectorDialog,
    departmentChooserDialog,
    CargoButtonGroupSlider,
    ConfirmDialogWindow,
    EstimateValidationDialog,
    cooperationVerifyDialog,
    BatchCheckingWindow,
    CheckingWindow,
    CargoIm
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    useOrderCenterMode: { type: Boolean, default: false },
    approveCooperationBusiness: { type: Boolean, default: false }
  },
  data() {
    return {
      locationImg,
      URL,
      imCacheKey: '',
      selectTypeNames: TYPE_NAMES,
      context: new VerifyWorkspaceContext(this.parentContext),
      pm: new VerifyWorkspacePM(this),
      SystemConstants,
      copyJobNum: 0,
      privilege: {
        aeBooking: {
          vesselEqTab: this.$checkPermission(['tab_AEBooking_VesselEqTab'])
        },
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView']),
          advanceCharge: this.$checkPermission(['tab_Charge_advanceCharge'])
        },
        chargeConfirm: {
          chargeConfirmView: this.$checkPermission(['tab_ChargeConfirm_chargeConfirmView'])
        },
        billTab: {
          billTabView: this.$checkPermission(['tab_billTab_billTabView'])
        },
        fileHistory: {
          fileHistoryView: this.$checkPermission(['tab_FileHistory_fileHistoryView'])
        }
      },
      commonInfo: {
        operateNameCode: -1, // 操作code
        jobState: '',
        jobTitle: '',
        jobLock: '',
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        detailTitleShowModel: 0, // 标题显示模式
        printEvent: null,
        showMessage: true
      },
      sopTooltipOffset: 0,
      action: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Payment.businessNumber'),
          colId: 'jobNo',
          field: 'jobNo',
          tooltip: (params) => {
            return params.data ? params.data.jobNo : ''
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return `<span>${params.value}</span>`
            }
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        onRowClicked: this.changeJob
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      templateSelectorDialog: {
        visible: false,
        ctx: new AirExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'AE',
      btn: {
        acceptRole: true, // 新增
        rejectRole: true, // 复制
        reviewThrough: true, // 复核通过
        reviewRefusal: true, // 复核拒绝
        pretrialReviewConfig: false // 复核配置
      },
      rejectWindow: {
        visible: false,
        jobNo: '',
        rejectCallBack: null
      },
      acceptDialog: { // 审核通过
        visible: false,
        job: null,
        submitCallBack: null,
        result: null
      },
      departmentChooserDialog: { // 选择部门弹窗
        visible: false,
        departments: [],
        saveBody: {},
        callback: () => {}
      },
      confirmDialogWindow: { // 信控验证使用
        visible: false,
        messageTitle: '',
        content: '',
        confirmCallBack: null,
        showConfirmBtn: ''
      },
      pretrialReviewConfig: false,
      creditRestrictionForBooking: 0, // 是否开启预审信控配置(0-不限制，1-弹窗确认，2-强制拦截)
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => {}
      },
      cooperationVerifyDialog: {
        visible: false,
        jobUuid: '',
        cooperate: null,
        submitCallBack: this.toAcceptCooperationVerifyCallBack,
        editable: true
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      sopTemplateConfig: {} // SOP模板配置
    }
  },
  computed: {
    user() {
      return this.context.user
    },
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    job() {
      return this.currentRow
    },
    sideBar() {
      return this.$store.getters.sidebar.opened
    },
    uploadParams() {
      const { job, user } = this
      return {
        jobNo: job.jobNo,
        mbl: job.mbl,
        uuid: job.uuid,
        createdBy: user.userId,
        createChineseName: user.chineseName,
        createEnglishName: user.englishName,
        documentType: 'other',
        documentName: 'other',
        isShared: false,
        op: false,
        sales: false,
        all: false,
        customer: false,
        consignee: false,
        shipper: false,
        destinationAgent: false,
        bookingAgent: false,
        creditRestrictionForBooking: 0 // 是否开启预审信控配置(0-不限制，1-弹窗确认，2-强制拦截)
      }
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus === undefined || this.paramsOfTab.cooperateStatus === null ? -1 : this.paramsOfTab.cooperateStatus
      if (this.paramsOfTab.cooperateCooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperateCooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperateBusinessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperateUuid) {
        return true
      }
      return false
    }
  },
  async created() {
    await this.context.prepareData()
    this.loadConfigData()
    getSopTemplateConfig({ lob: 'AE' }).then(res => {
      this.sopTemplateConfig = res.data
    })
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.loading = getLoading()
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      this.selectedRow = selectedRow
      this.$store.dispatch('app/setCanCloseModule', action === 'look')
      this.action = action
      if (!this.activeTabName) {
        this.paramsOfTab.masterFlag = this.currentRow.masterFlag = selectedRow.masterFlag
      }
      this.action = action
      if (selectedRow.uuid) {
        this.rowData = rowData
      } else {
        this.context.opDepartment = null
        await Promise.all([this.context.getDefaultAirExportJob(), this.context.getOpDepartment(this.office)])
        await this.buildNewRow(selectedRow)
        selectedRow.jobState = -1
        if (!Object.prototype.hasOwnProperty.call(selectedRow, 'path')) selectedRow.path = ''
        this.rowData = [...rowData, selectedRow]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        this.loading.close()
        this.setGridSelect(selectedRow)
        await this.onRowClicked({ data: selectedRow })
      })
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 加载配置项
    loadConfigData() {
      this.btn.acceptRole = this.$checkPermission(['button_AEPreVerify_accept'])
      this.btn.rejectRole = this.$checkPermission(['button_AEPreVerify_reject'])
      this.btn.reviewThrough = this.$checkPermission(['button_AEPreVerify_reviewThrough'])
      this.btn.reviewRefusal = this.$checkPermission(['button_AEPreVerify_reviewRefusal'])
      this.creditRestrictionForBooking = parseInt(this.config.get('CreditRestrictionForBooking'))
      this.pretrialReviewConfig = parseInt(this.config.get('PretrialReviewAE')) === 1
      this.btn.pretrialReviewConfig = parseInt(this.config.get('PretrialReviewAE')) === 1
    },
    // 新增时 填充默认值
    async buildNewRow(row) {
      const rowBackup = lodash.cloneDeep(row)
      const isNew = !Object.keys(row).length
      // 填充默认值
      new AirExportJob(row).fillDefaultValue()
      // CARGO-46980 空运订舱，取消新增业务自动带出ETD
      // const today = new Date()
      // row.etd = DateUtils.customFormat(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, today.getHours(), today.getMinutes()), 'YYYY-MM-DD')
      row.lob = this.lob
      const localCurrency = RateUtil.localCurrencyByOffice()
      row.currency = localCurrency
      row.cargoType = 'GC'
      row.paymentTermMBL = 'PP'
      const l = getCacheListByKey(basicCacheKeys.basic_data_PaymentTerm)
      if (l && l.length > 0) {
        row.paymentTermHBL = l[0].code
      }
      row.paymentTermMBL = 'PP'
      row.taxNature = 0
      row.bookingTerm = BookingTerm.SB_BOOKING_TYPE.code
      row.cargoSource = CargoSource.NC_CARGO_SOURCE.code
      row.landTransportation = false
      const office = this.$store.getters.currentOffice
      if (office) {
        row.opOffice = office.officeId
        row.loadingPortCode = office.airport
      }
      await getDepartmentIdOfRole({ 'shape': 'op', 'branchId': this.$store.getters.currentOfficeId }).then(res => {
        const opDepartmentId = res.data
        if (opDepartmentId && opDepartmentId > 0) {
          row.op = this.user.userId
          row.opOffice = office.officeId
          if (this.user.defaultDepId > 0 && this.user.defaultOfficeId === office.officeId) {
            row.opDepartment = this.user.defaultDepId
          } else {
            row.opDepartment = opDepartmentId
          }
        }
      })
      if (row.opOffice === 0) {
        row.opOffice = office.officeId
      }
      const aEDefaultDeliveryAgent = this.config.get('AEDefaultDeliveryAgent')
      if (aEDefaultDeliveryAgent) {
        row.deliveryAgent = aEDefaultDeliveryAgent
      } else {
        row.deliveryAgent = 0
      }
      if (row && row.masterFlag) { // 主票
        row.masterFlag = true
        row.mblOnly = true
        row.operateType = parseInt(AirExportConstants.CONSOLE.code)
      } else { // 小票
        row.masterFlag = false
        let operate = 0
        const aEDefaultJobOperate = LocalStorageUtils.getConfiguration('AEDefaultJobOperate')
        if (aEDefaultJobOperate) {
          operate = Number(aEDefaultJobOperate)
        }
        row.mblOnly = (operate === AirExportConstants.DIRECT.code)
        row.operateType = operate
        row.copyOnly = false
        row.jobState = -1
        row.preverifyState = 1
      }
      row.path = ''
      // 贸易方式(老的cargo是写在LocalCacheComboBox下拉框组件里面，默认选中一般贸易)
      const tradeTerms = await getSpecificBasicData(basicCacheKeys.basic_data_TradeTerm)
      if (tradeTerms && tradeTerms.length > 0) {
        for (const tradeTerm of tradeTerms) {
          if (tradeTerm.name === '一般贸易') {
            row.tradeTerm = tradeTerm.code
          }
        }
      }
      Object.assign(row, this.context.defaultAirExportJob)
      if (!row.destinationPortCode) {
        row.destinationPortCode = row.dischargingPortCode
      }
      if (!isNew && !row.masterFlag) {
        Object.assign(row, rowBackup)
      }
      if (!row.sellingCurrency) {
        row.sellingCurrency = localCurrency
      }
      if (!row.buyingCurrency) {
        row.buyingCurrency = localCurrency
      }
      // CARGO-53866 东丽 新增业务 销售默认带入当前登录人
      await JobUtils.loadingDlwlSales(row, this)
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid || item.data.jobUuid
        const rowKey = row.uuid || row.jobUuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          break
        }
      }
    },
    // 左侧列表切换job
    async changeJob(event) {
      const result = event.data
      if (result) {
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        await this.onRowClicked({ data: result })
      }
    },
    // 行点击
    async onRowClicked(event) {
      this.loading = getLoading()
      if (!event.data) {
        this.loading.close()
        return
      }
      if (this.action === 'look') {
        this.getImGroupFunc(event)
      }
      this.currentRow = null
      const job = event.data
      const jobVersion = job.version
      // 若选中提单拆并单,则需要找到其父级job
      if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === job.jobUuid) {
            this.currentRow = item
            break
          }
        }
        this.setGridSelect(this.currentRow)
      } else {
        // 本身选中就是job
        this.currentRow = job
      }
      let loadCooperate = false
      // 加载job详细信息
      const jobModel = new AirExportJob(this.currentRow)
      if (this.currentRow.uuid) {
        if (!jobVersion || jobVersion === 0) this.currentRow.version = 0 // version为0时可以重新加载job
        await jobModel.loadJobRelated({
          job: true, // 脏数据，需要重新载入
          lclSlaves: this.currentRow.masterFlag,
          charges: true,
          orderCenterMode: this.useOrderCenterMode,
          cooperateBranchId: this.cooperateBranchId
        })
        loadCooperate = true
        if (!this.currentRow.path) {
          this.setBasicData(this.currentRow)
          this.gridApi.refreshCells({ force: true })
        }
      } else {
        jobModel.lclSlaves = jobModel.lclSlaves || []
        jobModel.charges = jobModel.charges || []
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && job.cooperate && job.cooperate.uuid) {
          console.log('job.cooperate===', job.cooperate)
          // 记录原值
          job.opOffice_original = job.opOffice // 分公司
          job.op_original = job.op // 操作
          job.csr_original = job.csr // 客服
          job.overseaOp_original = job.overseaOp // 海外操作
          job.dc_original = job.dc // 单证
          job.planner_original = job.planner // 航线负责人
          job.opDepartment_original = job.opDepartment // 操作部门
          //
          job.opOffice = job.cooperate.branchId // 分公司
          job.op = job.cooperate.opId // 操作
          job.csr = job.cooperate.csrId // 客服
          job.overseaOp = job.cooperate.overseaOp // 海外操作
          job.dc = job.cooperate.dcId // 单证
          job.planner = job.cooperate.planner // 航线负责人
          job.opDepartment = job.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(job, job.cooperate)
          //
          job.cooperateUuid = job.cooperate.uuid
          job.cooperateCooperateStatus = job.cooperate.cooperateStatus
          job.cooperateBusinessType = job.cooperate.businessType
          job.cooperateBranchId = job.cooperate.branchId
          job.cooperateOpId = job.cooperate.opId
          job.cooperateCsrId = job.cooperate.csrId
          job.cooperateOverseaOp = job.cooperate.overseaOp
          job.cooperateDcId = job.cooperate.dcId
          job.cooperatePlanner = job.cooperate.planner
          job.cooperateOpDepartment = job.cooperate.opDepartment
          job.cooperateSales = job.cooperate.sales
          job.cooperateCargoSalesId = job.cooperate.cargoSalesId
          job.cooperateUserDefinedRoleId1 = job.cooperate.userDefinedRoleId1
          job.cooperateUserDefinedRoleId2 = job.cooperate.userDefinedRoleId2
        }
      }
      this.initInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.$nextTick(() => {
        if (this.isNew) {
          this.activeTabName = this.getDefaultActiveName()
        } else {
          const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
          if (activePanes && activePanes.length === 0) {
            this.activeTabName = this.getDefaultActiveName()
          }
        }
        this.handleTabClick()
      })
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.loading = getLoading()
      const tabs = ['tabTradeDetail', 'tabTradeCommission', 'tabAdvanceCharge', 'tabSopState', 'tabFileHistory', 'tabFile']
      this.btn.enablePrint = tabs.includes(this.activeTabName)
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        // this.$logger.log('handleTabClick-isRefresh', isRefresh)
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
        this.loading.close()
      })
    },
    // 编辑
    editHandler(action) {
      // 协作状态
      if (this.currentRow.cooperateStatus !== -1 && this.useOrderCenterMode && !this.orderCenterBranch && this.approveCooperationBusiness) {
        if (this.currentRow.cooperateStatus !== SystemConstants.COOPERATE_STATUS_APPROVED.code) {
          const cooperateStatusStr = JobUtils.getStateName(this.currentRow.cooperateStatus, SystemConstants.COOPERATE_STATUS)
          this.$message.warning(this.$t('Message.CanNotEditJob', [this.$t('CargoMsg.Cargo_CooperateStatus') + cooperateStatusStr]))
          return
        }
        this.againShow(action)
        return
      }
      this.loading = getLoading()
      new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 150)
      }).then(async() => {
        // 开启，预审状态为待审核、已审核 允许编辑
        const stateStr = JobUtils.getStateName(this.currentRow.preverifyState, REMOTE_BOOKING_ALL_STATES)
        if (this.pretrialReviewConfig) {
          if (![1, 2].includes(this.currentRow.preverifyState)) {
            this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
            this.loading.close()
            return
          }
          if (![-1, 0].includes(this.currentRow.jobState)) {
            const stateStr = JobUtils.getStateName(this.currentRow.jobState, JOB_STATES)
            this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
            this.loading.close()
            return
          }
        } else {
          // 不开启，预审状态为待审核的允许编辑
          if (this.currentRow.preverifyState !== 1) {
            this.$message.warning(this.$t('Message.CanNotEditJob', [stateStr]))
            this.loading.close()
            return
          }
        }
        if (!await SecurityUtil.canEdit(new AirExportJob(this.currentRow))) {
          this.$message.info(this.$t('Message.NoPermissionToEditTheJob'))
          this.loading.close()
          return
        }
        this.againShow(action)
      })
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      this.loading = getLoading()
      const selectedRow = this.isNew ? row || {} : this.currentRow
      this.onShow(action, this.rowData, selectedRow)
    },
    // 保存海运业务【保存业务相关数据】
    async save() {
      // 当前页签结束后的处理
      if (this.activeTabName) {
        await this.endTabHandler(this.activeTabName)
      }
      const body = {}
      try {
        for (const item of [...this.pendTabSet, 'other']) {
          let tabData = null
          if (item !== 'other') {
            // 各页签的保存数据
            const getSubmitData = this.$refs[item].getSubmitData
            if (getSubmitData && typeof getSubmitData === 'function') {
              /* 获取各页签需要保存的数据 */
              const result = this.$refs[item].getSubmitData()
              if (result instanceof Promise) {
                tabData = await result
              } else {
                tabData = result
              }
            }
          } else {
            // 被联动修改了的数据
            tabData = this.context.modifiedData
          }

          if (!tabData) continue
          // this.$logger.log('tabData' + item, tabData)
          // 将不同页签相同key的集合进行数据合并
          for (const key in tabData) {
            const tabValue = tabData[key]
            // this.$logger.log('tabValue：' + item, tabValue)
            if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
            const bodyValue = body[key]
            // this.$logger.log('bodyValue：' + item, bodyValue)
            if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
            // 将数组进行合并
            if (Array.isArray(tabValue)) {
              if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                const bodyMap = new Map()
                if (bodyValue && bodyValue.length > 0) {
                  for (const bodyKey of bodyValue) {
                    if (!bodyKey) continue
                    if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                  }
                }
                if (tabValue && tabValue.length > 0) {
                  for (const tabKey of tabValue) {
                    if (!tabKey || bodyValue.includes(tabKey)) continue
                    if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                    bodyValue.push(tabKey)
                  }
                }
              } else {
                tabValue.push(bodyValue)
                body[key] = tabValue
              }
              delete tabData[key]
            }
          }
          Object.assign(body, tabData)
        }
        // 还原接单分公司
        if (this.useOrderCenterMode) {
          if (body.job && body.job.cooperateUuid) {
            body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
            body.job.op = body.job.op_original || body.job.op // 操作
            body.job.csr = body.job.csr_original || body.job.csr // 客服
            body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
            body.job.dc = body.job.dc_original || body.job.dc // 单证
            body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
            body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
            JobUtils.restoreJobFromCooperateInfo(body.job)
          }
        }
        // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
        if (Reflect.has(body, 'job') && body.job) {
          for (const key in body.job) {
            // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
            if (typeof body.job[key] === 'object') delete body.job[key]

            // 保存时需要将sop显示列排除
            if (key.indexOf('_sop_') !== -1 && key.startsWith('_sop_')) delete body.job[key]
          }
        }
        this.doNotClickTabData(body)
        this.cleanCircleObject(body)
      } catch (err) {
        this.loading.close()
        if (err instanceof TabError) {
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
      // 在保存前进行校验
      const bodyJob = body.job || null
      if (!(await this.pm.checkBeforeSave(bodyJob))) {
        this.loading.close()
        return
      }
      // 新增时，判断在新建job是否需要选择部门，因为用户的模块权限可以会挂在多个部门里面
      if (!bodyJob.uuid) {
        const params = { 'shape': 'AEBooking', 'currentDepartmentId': this.$store.getters.currentDeptId, 'currentOfficeId': this.$store.getters.currentOfficeId }
        await needConfirmDepartment(params).then(res => {
          if (res.data.result) {
            this.departmentChooserDialog.departments = res.data.departments
            this.departmentChooserDialog.saveBody = body
            this.departmentChooserDialog.visible = true
          } else {
            this.continueSave(body)
          }
        })
      } else {
        this.continueSave(body)
      }
    },
    departmentChooserDialogCallback(departmentId) {
      if (departmentId) {
        const job = this.departmentChooserDialog.saveBody.job
        job.opDepartment = departmentId
        this.departmentChooserDialog.visible = false
        this.continueSave(this.departmentChooserDialog.saveBody)
      } else {
        this.departmentChooserDialog.visible = false
      }
    },
    async continueSave(body) {
      // 后端触发SOP使用
      if (!this.isNew) body.jobUuid = this.job.uuid
      // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
      await SopUtil.checkSopTemplate(body.job, this, null, null, this.sopTemplateConfig)
      // 保存 访问数据库
      body.action = this.action
      this.loading = getLoading() // 这个loading要放在验证之后
      await saveAeBookingSpace(body).then(res => {
        const result = res.data.job
        if (result) {
          Object.assign(this.currentRow, result)
          this.currentRow.version = 0
          this.currentRow.blocked = result.blocked
          this.currentRow.jobUuid = result.uuid
          this.currentRow.dataType = result.masterFlag ? 1 : 2 // 1、主票 1、小票
          if (this.currentRow.lclMasterUuid) {
            this.currentRow.path = result.lclMasterUuid + ',' + result.uuid
          } else {
            this.currentRow.path = result.uuid
          }
          this.isRefresh = true
        }
        // 重置子表数据【将job相关信息置空，然后从库里重新加载】
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
      }).catch((err) => {
        console.log(err)
        this.loading.close()
      })
      // 保存成功后各业签执行的回调方法
      for (const item of this.pendTabSet) {
        const executeTask = this.$refs[item].executeTask
        if (executeTask && typeof executeTask === 'function') {
          /* 保存成功后的回调 */
          const result = this.$refs[item].executeTask()
          if (result instanceof Promise) {
            await result
          }
        }
      }
      this.loading.close()
      await this.againShow('look', this.currentRow)
      if (JobUtils.isBlockJob(this.currentRow)) {
        setTimeout(() => {
          this.$message.warning(this.$t('SeaExport.CheckCreditSaveTip'))
        }, 2000)
      }
      this.$message.success(this.$t('Message.SaveSuccessfully'))
    },
    // 复制
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const job = this.currentRow
      if (!body || !job || !isCopy) return
      if (!Object.prototype.hasOwnProperty.call(body, 'charges') && job.charges && job.charges.length > 0) {
        Object.assign(body, { charges: job.charges })
      }
      if (!Object.prototype.hasOwnProperty.call(body, 'trucking') && job.trucking && job.trucking.length > 0) {
        Object.assign(body, { truckingInfo: job.trucking })
      }
      if (!Object.prototype.hasOwnProperty.call(body, 'warehouseInfo') && job.warehouseInfo && job.warehouseInfo.length > 0) {
        Object.assign(body, { warehouseInfo: job.warehouseInfo })
      }
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    // 加载完job走这里
    initInfo() {
      this.showJobState()
      this.showJobTitle()
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.jobState = ''
        this.commonInfo.jobLock = ''
        this.commonInfo.jobChangeState = ''
        return
      }
      if (this.currentRow.jobState && this.currentRow.preverifyState && Number(this.currentRow.preverifyState) === 2 && Number(this.currentRow.jobState) === -1 && this.btn.pretrialReviewConfig) {
        this.commonInfo.jobState = this.$t('SeaExport.StateVerifyingReview')
      } else {
        this.commonInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      }
      this.commonInfo.jobLock = JobUtils.isBlockJob(this.currentRow) ? this.$t('Message.Locked') : ''
      // 改单状态
      if (Number(this.config.get('IsCommittedAllowAddCost')) === 1) {
        this.commonInfo.jobChangeState = ColumnUtils.getJobChangeState(this.currentRow)
      }
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = job.jobNo
      if (job.customerId) {
        const cmp = await Company.getCompanyById(job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await JobUtils.getBillingTypeByCompany(cmp)
          jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + (this.$store.getters.language === 'zh' ? cmp.chineseName : cmp.englishName) + creditTerm + '</span><span>' + billingType + '</span>'
        }
      }
      this.commonInfo.jobTitle = jobTitle
    },
    goBack() {
      this.activeTabName = ''
      this.action = ''
      this.$store.dispatch('app/setCanCloseModule', true)
      this.$emit('back', this.isRefresh)
    },
    // 查看
    lookHandler() {
      this.againShow('look', this.currentRow)
    },
    // 打印
    onPrint() {
      if (JobUtils.isBlockJob(this.job)) {
        this.$message.info(this.job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
        return
      }
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.job.uuid
        }
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 合并当前job【刷新当前job】
    mergeCurrentRow(res) {
      if (res && res.data) {
        Object.assign(this.currentRow, res.data)
        this.currentRow.uuid = res.data.uuid
        this.isGetNewJobInfoFromDb = true
        this.isRefresh = true
      }
    },
    transferTargetRow(action, jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        this.onShow(action, this.rowData, selectedRow)
      }
    },
    // 加入小票
    addSlavedJob(jobs) {
      for (const job of jobs) {
        job.jobUuid = job.uuid
        job.parentUuid = job.lclMasterUuid
        job.path = job.lclMasterUuid + ',' + job.uuid
        job.dataType = 2 // 小票
        const oldIndex = this.rowData.findIndex(p => p.uuid === job.uuid)
        if (oldIndex >= 0) {
          this.rowData.splice(oldIndex, 1)
        }
      }
      this.rowData = [...this.rowData, ...jobs]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    // 移除小票
    removeJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      /* for (const row of rows) {
        row.lclMasterUuid = ''
        row.mbl = ''
        row.parentUuid = ''
        row.path = row.uuid
        row.isCompleteRow = false
      }*/
      this.rowData = [...rows]
      this.$nextTick(() => {
        this.setGridSelect(this.currentRow)
      })
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 复制
    copyJobHandler() {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.$emit('copy', this.currentRow)
    },
    // 审核通过
    acceptHandler(type) {
      this.acceptDialog.job = this.job
      this.acceptDialog.submitCallBack = this.acceptSubmitCallBack
      this.acceptDialog.visible = true
    },
    // 审核通过回调函数
    acceptSubmitCallBack(result) {
      this.acceptDialog.result = result
      if (result) {
        const jobKeys = []
        jobKeys.push(result.uuid)
        result.jobKeys = jobKeys
        const callBack = () => { batchCheckJobsCredit(jobKeys).then(res => this.checkCreditResultHandler(res)) }
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_BOOKING_VERIFY.code
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        if (useCheckRule) {
          // const hasCheckRule = await JobUtils.hasConfigCheckRule(checkNode, this.job.uuid, this.job.lob)
          const hasCheckRule = true
          if (hasCheckRule) {
            this.checkingManager(checkNode, callBack, null, result)
          } else {
            callBack()
          }
        } else {
          callBack()
        }
      }
    },
    // 验证规则配置公用checkingManager
    async checkingManager(checkNode, callBack, callBack2, newJob = null) {
      this.$logger.log('this.job', this.job)
      if (!this.job) return
      let checkType = true
      if (this.job.masterFlag) {
        const lclSlaves = await new AirExportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          checkType = false
          this.batchCheckingWindow.checkNode = checkNode
          this.batchCheckingWindow.jobs = [this.job, ... lclSlaves]
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.callBack2 = callBack2
          this.batchCheckingWindow.newJob = newJob
          this.batchCheckingWindow.visible = true
        }
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.newJob = newJob
        this.checkingWindow.visible = true
      }
    },
    // 信控验证返回结果
    checkCreditResultHandler(res) {
      const result = res.data
      if (result && this.creditRestrictionForBooking !== 0) {
        if (this.creditRestrictionForBooking === 2) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipOne')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = false
          this.confirmDialogWindow.confirmCallBack = null
          this.confirmDialogWindow.visible = true
          return
        }
        if (this.creditRestrictionForBooking === 1) {
          this.confirmDialogWindow.messageTitle = this.$t('SeaExport.CheckCreditTipTwo')
          this.confirmDialogWindow.content = result
          this.confirmDialogWindow.showConfirmBtn = true
          this.confirmDialogWindow.confirmCallBack = this.batchAudit
          this.confirmDialogWindow.visible = true
          return
        }
      }
      this.batchAudit()
    },
    // 审核通过
    batchAudit() {
      acceptJob(this.acceptDialog.result).then(res => {
        if (res.data) {
          Object.assign(res.data, this.currentRow)
        }
        this.$emit('refresh', this.currentRow)
        this.$message.success(this.$t('Message.AuditSuccessfully') + '！')
        this.refresh()
      })
    },
    // 审核拒绝
    rejectHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.rejectWindow.jobNo = this.currentRow.jobNo
      this.rejectWindow.rejectCallBack = this.isCooperate ? this.rejectCooperateCallBackHandler : this.rejectCallBackHandler
      this.rejectWindow.visible = true
    },
    // 审核拒绝回调函数
    rejectCallBackHandler(remark) {
      preVerifyReject({ 'jobKey': this.currentRow.jobUuid, 'remark': remark }).then(res => {
        if (res.data) {
          Object.assign(res.data, this.currentRow)
        }
        this.$emit('refresh', this.currentRow)
        this.$message.success(this.$t('SeaExport.RefuseSuccess'))
        this.refresh()
      })
    },
    // 复核通过 preverifyState = 5
    btVerifyReviewThroughHandler() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      const item = {}
      item.uuid = this.currentRow.uuid
      item.jobKeys = [this.currentRow.uuid]
      item.preverifyState = 5
      this.loading = getLoading()
      reviewThrough(item).then(res => {
        if (res.data) {
          Object.assign(res.data, this.currentRow)
        }
        this.$emit('refresh', this.currentRow)
        this.$message.success(this.$t('SeaExport.ReviewSuccess'))
        this.refresh()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 复核拒绝 preverifyState = 6
    btVerifyReviewRefusalHandler() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.$message.warning(this.$t('Message.PleaseSelectJob'))
        return
      }
      this.loading = getLoading()
      const item = {}
      item.uuid = this.currentRow.uuid
      item.preverifyState = 6
      reviewRefusal(item).then(res => {
        if (res.data) {
          Object.assign(res.data, this.currentRow)
        }
        this.$emit('refresh', this.currentRow)
        this.$message.success(this.$t('SeaExport.ReviewRejectedSuccess'))
        this.refresh()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 审核通过
    acceptCooperateHandler(type) {
      if (!this.currentRow) {
        this.$message.warning(this.$t('Message.SelectJob'))
        return
      }
      this.cooperationVerifyDialog.jobUuid = this.currentRow.uuid
      const cooperate = {
        uuid: this.currentRow.cooperateUuid,
        branchId: this.currentRow.cooperateBranchId,
        opId: this.currentRow.cooperateOpId,
        csrId: this.currentRow.cooperateCsrId,
        overseaOp: this.currentRow.cooperateOverseaOp,
        dcId: this.currentRow.cooperateDcId,
        planner: this.currentRow.cooperatePlanner,
        sales: this.currentRow.cooperateSales,
        cargoSalesId: this.currentRow.cooperateCargoSalesId,
        userDefinedRoleId1: this.currentRow.cooperateUserDefinedRoleId1,
        userDefinedRoleId2: this.currentRow.cooperateUserDefinedRoleId2,
        opDepartment: this.currentRow.cooperateOpDepartment,
        businessType: this.currentRow.cooperateBusinessType ? this.currentRow.cooperateBusinessType.split(',') : [],
        cooperateStatus: this.currentRow.cooperateCooperateStatus
      }
      console.log('cooperate', cooperate)
      this.cooperationVerifyDialog.cooperate = cooperate
      this.cooperationVerifyDialog.editable = false
      this.cooperationVerifyDialog.visible = true
    },
    toAcceptCooperationVerifyCallBack(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_APPROVED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.$emit('refresh', this.currentRow)
          this.$message.success(this.$t('SeaExport.AuditSuccess'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 协作状态: 拒绝
    rejectCooperateCallBackHandler(remark) {
      this.loading = getLoading()
      updateState({ jobUuid: this.currentRow.uuid, branchId: this.$store.getters.currentOffice.officeId,
        statusType: SystemConstants.STATUSTYPE_COOPERATE.code,
        status: SystemConstants.COOPERATE_STATUS_REFUSED.code,
        remark: remark }).then(res => {
        if (res && res.data) {
          this.currentRow.cooperateStatus = res.data[0].cooperateStatus
          this.$emit('refresh', this.currentRow)
          this.$message.success(this.$t('SeaExport.RefuseSuccess'))
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', result.destinationPortCode, 'englishName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    // 刷新
    refresh() {
      this.isGetNewJobInfoFromDb = true
      this.againShow(this.action, this.job)
    },
    saveDefaultVal() {
      const loading = getLoading()
      EntityDefaultValueUtil.getInstance().saveEntityDefaultValue(['Job', 'AirExportJob'], this.paramsOfTab).then(() => {
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style lang="scss">
.booking-details {
  .el-tabs__nav-prev,.el-tabs__nav-next{
    line-height: 29px;
  }
  .el-tabs__content{
    overflow: auto
  }
  .el-tab-pane{
    height: 100%;
  }
}
</style>
